export function getTotalWeight<
  T extends {
    weight: number
  },
>(items: Array<T>): number {
  return items.map((item) => item.weight).reduce((sum, current) => Number(sum) + Number(current), 0)
}
export const getTotalWeightColor = (totalWeight: number): string =>
  totalWeight > 100 || totalWeight < 100 ? '#c51b1f' : '#78a22f'
